import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { TransferRequest } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Holding/Transfer';
import { SUC_ACC_XFER_REQ, ERR_ACC_XFER_REQ } from '../../../../utils/strings';

export const useAcceptTransferRequest = () => {
  const { submit } = useExerciseSubmission(
    TransferRequest.TransferRequest_Accept,
    SUC_ACC_XFER_REQ,
    ERR_ACC_XFER_REQ,
  );
  return submit;
};
